module.exports = __webpack_public_path__ + "static/media/FIRE.96323e82.png";